import { FC } from "react";

import { useIncidentBanner } from "src/hooks/use-incident-banner";

import { IncidentBanner } from "./incident-banner";
import { OverageBanner } from "./overage-banner";
import { TrialBanner } from "./trial-banner";
import { SnowflakePasswordDeprecationBanner } from "./snowflake-password-deprecation-banner";
import { OrganizationRequiresSensitiveDataControlsBanner } from "./organization-requires-sensitive-data-controls-banner";
import { DbtDeprecationBanner } from "./dbt-deprecation-banner";
import { SandboxBanner as NativeDeliverySandboxBanner } from "src/cep/components/sandbox-banner";

/**
 * Incident banners are large. To save space, hide other secondary banners when it's enabled.
 *
 * Render the following banners, if applicable, in order of precedence:
 *  1. Incident Banner
 *  2. Overage Banner, Trial Banner, Snowflake Password Deprecation Banner,
 *     Organization Requires Sensitive Data Controls Banner, Daylight Savings
 *     Banner, Dbt Deprecation Banner
 */
export const SecondaryBanners: FC = () => {
  const { loading, incident, onDismiss } = useIncidentBanner();

  if (!loading && incident?.id) {
    return <IncidentBanner {...incident} onDismiss={onDismiss} />;
  }

  return (
    <>
      <OverageBanner />
      <TrialBanner />
      <SnowflakePasswordDeprecationBanner />
      <OrganizationRequiresSensitiveDataControlsBanner />
      {/*For now, we've decided not to show the DST banner due to banner fatigue.*/}
      {/*We may start showing this again in the future.*/}
      {/*<DaylightSavingsBanner />*/}
      <DbtDeprecationBanner />
      <NativeDeliverySandboxBanner />
    </>
  );
};
